module.exports = __webpack_public_path__ + "img/kontakt_1280.1ec5a853.png";